import { UAParser } from 'ua-parser-js';

interface INavigatorInfo {
  userAgent: string;
  maxTouchPoints: number;
}

const HANDHELD_DEVICE_TYPES = ['mobile', 'tablet', 'wearable'];
const HANDHELD_OS_NAMES = ['iOS', 'Android'];

/**
 * AVS-4513: picking a camera or microphone is a desktop/laptop feature; phones and tablets use the OS default device.
 */
export function canSelectInputDevice(
  { userAgent, maxTouchPoints }: INavigatorInfo = {
    userAgent: navigator.userAgent,
    maxTouchPoints: navigator.maxTouchPoints ?? 0,
  }
): boolean {
  const { device, os } = UAParser(userAgent);

  if (HANDHELD_DEVICE_TYPES.includes(device.type ?? '') || HANDHELD_OS_NAMES.includes(os.name ?? '')) {
    return false;
  }

  // iPadOS reports a Mac by default; real Macs have no touch screen.
  const isIPadAsMac = os.name === 'Mac OS' && maxTouchPoints > 1;
  return !isIPadAsMac;
}
